module.exports = __webpack_public_path__ + "static/media/light.f5be6232.png";